export default __webpack_public_path__ + "static/media/YODA-1920.1099377e.webp";